import type { CreateInventoryItemRequest, InventoryGroup } from '@ck/api-client'

export interface InventoryItemDraft {
  sku: string
  name: string
  group: InventoryGroup
  unit: string
  minimumQuantity: string
  description: string
}

export function emptyInventoryItemDraft(): InventoryItemDraft {
  return {
    sku: '',
    name: '',
    group: 'mechanics',
    unit: '',
    minimumQuantity: '',
    description: ''
  }
}

export function toCreateInventoryItemRequest(draft: InventoryItemDraft, minimumQuantity: number): CreateInventoryItemRequest {
  const sku = draft.sku.trim()
  const name = draft.name.trim()
  const unit = draft.unit.trim()
  if (!sku || !name || !unit) throw new Error('Informe SKU, nome e unidade.')

  return {
    sku,
    name,
    group: draft.group,
    unit,
    minimumQuantity,
    description: draft.description.trim() || null
  }
}
